import React from 'react';
import {List, Map} from 'immutable';
import classnames from 'classnames';
import {ClassroomModelV1} from 'src/client/CreateAssignmentV2/CreateAssignment.store';

import {Text} from '@albert-io/atomic';
import {callAction} from 'client/framework';
import {pluralize} from 'lib/stringUtils';

import createAssignmentActions from '../../CreateAssignment.actions';

interface CreateAssignmentAllRecipientsOptionProps {
  classrooms: List<ClassroomModelV1>;
  recipients: Map<string, any>;
}
const CreateAssignmentAllRecipientsOption = ({
  classrooms,
  recipients
}: CreateAssignmentAllRecipientsOptionProps) => {
  const allRecipients = recipients.reduce((acc, recipient) => {
    return acc + recipient.get('students').size;
  }, 0);

  const allStudents = classrooms.reduce((acc, classroom) => {
    return acc + classroom.getStudents().size;
  }, 0);

  let checked;
  if (allStudents === 0) {
    checked = classrooms.size === recipients.size;
  } else {
    checked = allStudents === allRecipients;
  }

  const indeterminate = allRecipients > 0 && allRecipients < allStudents;

  let label: string;
  if (checked) {
    label = `All ${classrooms.size > 1 ? `${classrooms.size} ` : ''}classrooms selected`;
  } else if (indeterminate) {
    label = `${recipients.size} ${pluralize('classroom', recipients.size)} selected`;
  } else {
    label = 'Select all classrooms';
  }

  const handleSelectAll = (e) => {
    const isChecked = e.key === 'Enter' ? !e.target.checked : e.target.checked;
    classrooms.forEach((classroom) => {
      const recipientData = Map({
        addRecipients: isChecked,
        autoAssignNewEnrollees: isChecked,
        classroomId: classroom.getId(),
        classroomName: classroom.getName(),
        students: classroom.getStudents()
      });
      callAction(createAssignmentActions.SET_ACTIVE_RECIPIENT_GROUP, classroom.getId());
      callAction(createAssignmentActions.SET_MULTIPLE_RECIPIENTS, recipientData);
    });
  };

  return (
    <div className='acf__recipient-group'>
      <div className='acf__recipient-item-wrapper'>
        <div className='acf__recipient-item'>
          <label className='acf__recipient-item-checkbox-wrapper' htmlFor='all_classes'>
            <input
              checked={checked}
              id='all_classes'
              onChange={handleSelectAll}
              onKeyDown={handleSelectAll}
              type='checkbox'
              value='all_classes'
            />
            {/* eslint-disable jsx-a11y/control-has-associated-label */}
            <span
              aria-checked={checked}
              className={classnames('checkbox-checkmark', 'acf__recipient-item-checkbox', {
                'acf__recipient-item-checkbox-indeterminate': indeterminate
              })}
              role='checkbox'
            />
          </label>
          <div className='u-display_flex u-flex-direction_column'>
            <label className='acf__recipient-item-label' htmlFor='all_classes'>
              <Text bold emphasis='high' size='m'>
                {label}
              </Text>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateAssignmentAllRecipientsOption;
